import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Sorry! url not found. Please, visit a valid page</h2>
            <h1>404</h1>
        </div>
    );
};

export default NotFound;